module.exports = __webpack_public_path__ + "img/bandage_fill.26ee4558.svg";